import React from 'react';
import { useValidateTier } from '../hooks/useTier';
import { Col } from 'react-bootstrap';
import { Help } from '../components/shared/Help';
import { Module } from '../components/tier/Module';
import { useIbv } from '../hooks/useIbvDialog';
import { useSelector } from 'react-redux';
import { useHideMenu } from '../hooks/useHelpMenu';
import {useSwitchDesign} from '../hooks/useSwitchDesign';
import AltModule from '../components/user/AltTier/AltModule';
import { MainContainer } from '../hooks/useAltModule';
import { Loading } from '../components/shared/Loading';

/**
 * Page tier
 * @returns {JSX}
 */
const TierPage = () => {
  useValidateTier();
  const { isIBVVerified, isIBVShown, setAlert } = useIbv();
  const { autoLoginURL } = useSelector(state => state.base);
  const { showHelperInfo } = useHideMenu({isIBVShown, autoLoginURL});
  const { loading } = useSelector(state => state.base);

  const { isNewDesign, switchBtn } = useSwitchDesign()

  return (
    <>      
      { switchBtn }
      { loading && <Loading/> }
      { isNewDesign ? (
        <MainContainer>
          <Col className="" 
            xl={{
              span:8, offset:2
            }} 
            md={12} 
            xs={12}>
            <AltModule
              shouldShowIBV={isIBVShown && !isIBVVerified}
              setAlert={setAlert}
            />
          </Col>
        </MainContainer>   
      ) : (
        <>
          <Col className="p-0" xl={3} md={4} xs={12}>
            <Help 
              backButton={false} 
              show={showHelperInfo}
            />
          </Col>
          <Col className="p-4" xl={9} md={8} xs={12}>
            <Module 
              shouldShowIBV={isIBVShown && !isIBVVerified}
              setAlert={setAlert}
            />
          </Col>
        </>   
      ) }  
    </>
  );
};
export default TierPage;